import React, { useState } from "react";
import gql from "../../../../../api/gql";
import _ from "lodash";
import { Button, Drawer, Form, Input, message } from "antd";
const UpdateCategory = ({ onChange, data }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const onFinish = (values) => {
    const {id} = data;
    setLoading(true);
    const { title } = values;
    const mutation = `mutation updateBannerCategory($title: String!, $id: String!){
  	updateBannerCategory(title: $title, id: $id){
            id
        }
    }    
    `;
    gql
      .request(mutation, {
        title,
        id
      })
      .then((res) => {
        onChange();
        form.resetFields();
        onClose();
      })
      .catch((err) => {
        message.error('Something went wrong, please try again!');
        setLoading(false);
      });
  };
  const onFinishFailed = (errorInfo) => {};

  return (
    <>
      <Button onClick={showDrawer} style={{ marginLeft: 5 }} type="primary">
        Edit
      </Button>
      <Drawer
        title={`Edit category id: ${data.id}`}
        placement="left"
        closable={false}
        onClose={onClose}
        visible={open}
      >
        <Form
          layout="vertical"
          form={form}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Title"
            name="title"
            rules={[
              {
                required: true,
                message: "Please input title!",
              },
            ]}
          >
            <Input defaultValue={data.title} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Update
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default UpdateCategory;
